const cookies = require("cookie-helper");

module.exports.watchDownload = function(token, callback) {
    var interval = window.setInterval(function() {
        if (cookies.get("download-token") === token) {
            clearInterval(interval);
            cookies.delete("download_token");
            callback();
        }
    }, 500);
};

module.exports.downloadAsFile = function(fileName, contentType, content) {
    Promise.all([import("file-saver"), import("blob.js")]).then(deps => {
        let [FileSaver] = deps;
        var blob = new Blob([content], { type: contentType });
        FileSaver.saveAs(blob, fileName);
    });
};
